import { observer } from 'mobx-react-lite'
import React from 'react'
import { Typography } from 'shared/ui'
import { GreetingAudioBlockEditContent } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/blocks/GreetingAudioBlock'
import styles from './styles.module.scss'
import { type IVRStore } from '../../store/IVRStore'

type IActionEditContentProps = {
  store: IVRStore
}

export const IVRActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { greetingMessageStore } = store

  return (
    <div className={styles.wrap}>
      <div>
        <div className={styles.greetingHeader}>
          <Typography variant={'body-md-medium'} ariaLabel={'title'}>
            Greeting message
          </Typography>
          <Typography variant={'body-md-regular'} ariaLabel={'desc'} color={'tertiary'}>
            Example: For sales press 1 for support press 2
          </Typography>
        </div>
        <GreetingAudioBlockEditContent store={greetingMessageStore} />
      </div>
    </div>
  )
})
